
import * as React from 'react';

const CKEDITOR = require('ckeditor4-react');

interface ICKEditorProps {
  value: string;
  onChange?: (value: any) => void;
}
interface ICKEditorState {
  value: string;
}

class CKEditor extends React.Component<ICKEditorProps, ICKEditorState> {

  private config = {
    // Disable automatic HTML parsing
    allowedContent : true
  };

  constructor(props: any, context: any) {
    super(props, context);
    this.state = { value: this.props.value };
  }

  public render() {
    return <CKEDITOR onBeforeLoad={this.errorWorkaround} config={this.config} data = {this.props.value} onChange={this.onChange}/>
  }

  private errorWorkaround = (editor : any) => {
    /**
     * Workaround error: editor-element-conflict
     * https://github.com/ckeditor/ckeditor4-react/issues/57
     */
    editor.disableAutoInline = true;    
  }

  private onChange = (event : any) => {
    this.setState({ value : event.editor.getData() });
    if(this.props.onChange) this.props.onChange(event.editor.getData());
  }
}

export default CKEditor;


// WEBPACK FOOTER //
// ./src/CKEditor/index.tsx